export interface CategoryItem {
  key: string;
  label: string;
  desc: string;
  icon: string;
  count: number;
}

export interface ProcessStep {
  step: string;
  title: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  quote: string;
}

export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const brand = {
  name: "黑暗爆料",
  shortName: "暗料",
  tagline: "把看不见的规则，摆到台面上",
  slogan: "潜规则 · 圈内规则 · 行业黑幕 · 暗箱操作曝光",
  intro:
    "黑暗爆料是一个专注行业观察与消费警示的中文内容平台。我们用调查笔记的方式，拆解潜规则、圈内规则、行业黑幕与灰色地带背后的运作逻辑，让关注者在做出决定之前，多一层可对照的判断依据。",
  email: "tips@heianbaoliao.example.com",
  since: "2019",
  established: "2019 年创立",
  promise: "可核验 · 可对照 · 不给结论只给方法",
};

export const stats = [
  { value: "480+", label: "已梳理调查档案" },
  { value: "26", label: "覆盖行业领域" },
  { value: "63 万", label: "累计阅读人次" },
  { value: "94%", label: "读者反馈有实际帮助" },
];

export const categories: CategoryItem[] = [
  {
    key: "consumer",
    label: "消费陷阱",
    desc: "价格把戏、隐形扣费、办卡套路与售后推诿的常见链路拆解。",
    icon: "ri-shopping-bag-3-line",
    count: 42,
  },
  {
    key: "industry",
    label: "行业潜规则",
    desc: "装修、二手车、直播、医美等高频行业中不明说的默认规矩。",
    icon: "ri-node-tree",
    count: 37,
  },
  {
    key: "backroom",
    label: "暗箱操作",
    desc: "招投标、渠道返点、数据造假等不透明环节的运作方式。",
    icon: "ri-eye-off-line",
    count: 29,
  },
  {
    key: "power",
    label: "权力内幕",
    desc: "审批、评奖、资源分配中的关系网络与利益输送路径。",
    icon: "ri-government-line",
    count: 18,
  },
  {
    key: "gray",
    label: "灰色地带",
    desc: "游走在合规边缘、监管口径模糊地带的常见形态。",
    icon: "ri-foggy-line",
    count: 24,
  },
  {
    key: "career",
    label: "职场招聘",
    desc: "押金、内推费、试用期套路与劳动合同里的隐性条款。",
    icon: "ri-briefcase-4-line",
    count: 31,
  },
];

export const processSteps: ProcessStep[] = [
  {
    step: "01",
    title: "线索汇集",
    desc: "汇总读者来信、公开投诉与行业从业者反馈，标记重复出现的模式而非孤立个案。",
  },
  {
    step: "02",
    title: "模式比对",
    desc: "把零散线索放进同一张对照表，找出逃不掉的共同环节：谁定价、谁经手、谁分利。",
  },
  {
    step: "03",
    title: "环节拆解",
    desc: "按时间顺序还原一个普通用户真实会走到哪一步、在哪一步开始失去主动权。",
  },
  {
    step: "04",
    title: "方法输出",
    desc: "把拆解结果转成可以带走的避坑要点与提问清单，不含未经核实的指向性指控。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "周女士",
    role: "第一次装修的业主",
    quote:
      "看完增项那篇档案，我才知道合同里「按实际发生量结算」这句话有多要命。签合同前照着清单逐条问了一遍，省下的钱够买全屋家电了。",
  },
  {
    name: "阿凯",
    role: "二手车评估从业者",
    quote:
      "调表那段写得很实在，没有夸张。我们内部确实靠几个细节就能看出来，但他们把它讲成了普通人也能自己核对的方法。",
  },
  {
    name: "林小姐",
    role: "应届毕业生",
    quote:
      "入职前被要求先交「培训押金」的时候，我脑子里直接跳出他们那篇职场档案。当场拒绝，后来那家公司连办公地址都查不到。",
  },
  {
    name: "老崔",
    role: "三线城市个体户",
    quote:
      "供货、返点、账期那一套，我踩了三年才摸明白。他们一篇文章讲清楚了，早两年看到能少亏不少。",
  },
];

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "黑暗爆料的内容是真实的调查吗？",
    answer:
      "我们做的是公开现象的归纳与模式拆解，而不是针对特定企业或个人发布未核实的指控。所有档案来源于读者来信、公开投诉记录与从业者反馈，我们会去掉可识别的企业名称，只保留可复现的流程与环节，便于读者对照自身经历。",
  },
  {
    id: "faq-2",
    question: "为什么不直接点名具体公司？",
    answer:
      "点名需要完整的证据链与法律背书，这超出内容平台的能力边界。更重要的是，单个案例会过时，而运作模式不会。我们更希望读者学到的是一套判断方法，换到任何行业都能用。",
  },
  {
    id: "faq-3",
    question: "我可以提供自己遇到的线索吗？",
    answer:
      "非常欢迎。你可以通过「提供爆料线索」表单提交，尽量写清楚时间、环节和对方让你签的字。我们会对来源做匿名处理，也不会公开你的联系方式。",
  },
  {
    id: "faq-4",
    question: "内容多久更新一次？",
    answer:
      "档案库保持每周更新 2 到 3 篇的节奏，遇到集中反馈的话题会做成专题连载。订阅「爆料更新」后，新档案上线时你会收到提醒。",
  },
  {
    id: "faq-5",
    question: "文章里的避坑要点能作为法律依据吗？",
    answer:
      "不能。避坑要点是经验性建议，用于帮你在签约、付款、谈话这些场景里多问一句、多留一手。涉及具体纠纷时，请以合同文本、监管规定和专业法律意见为准。",
  },
  {
    id: "faq-6",
    question: "平台会收费或者卖课吗？",
    answer:
      "不会。黑暗爆料的内容全部免费公开，我们没有付费社群、没有内推服务，也不会向读者要任何形式的费用。任何以我们名义收费的行为都与平台无关。",
  },
  {
    id: "faq-7",
    question: "为什么有些档案读起来像「聊了一半」？",
    answer:
      "因为有些环节我们只掌握到「怎么发生」，还没弄清楚「钱最后流去哪里」。与其给出一个听起来完整却站不住的结论，我们选择标注线索状态，等更完整的材料出现再补写。",
  },
];

export const principles = [
  {
    icon: "ri-shield-check-line",
    title: "不做未核实的指控",
    desc: "只写能复现的流程与环节，去掉可识别的企业名称，避免伤及无关方。",
  },
  {
    icon: "ri-search-eye-line",
    title: "结论让位于方法",
    desc: "比起告诉你谁坏，我们更想让你带走一套在下次决策前能用的提问清单。",
  },
  {
    icon: "ri-lock-2-line",
    title: "保护线索来源",
    desc: "对来信做匿名处理，不公开联系方式，也不把线索转交给任何第三方。",
  },
  {
    icon: "ri-refresh-line",
    title: "错了就改",
    desc: "档案会在页面标注最近修订时间，出现新信息或更正时公开说明改动内容。",
  },
];

export const navLinks = [
  { to: "/", label: "首页" },
  { to: "/cases", label: "调查档案" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export const footerGroups = [
  {
    title: "内容导航",
    links: [
      { to: "/cases", label: "全部档案" },
      { to: "/cases?category=consumer", label: "消费陷阱" },
      { to: "/cases?category=industry", label: "行业潜规则" },
      { to: "/cases?category=backroom", label: "暗箱操作" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/about#principles", label: "内容原则" },
      { to: "/faq", label: "常见问题" },
      { to: "/about#submit", label: "提供线索" },
    ],
  },
];